import React, { Component } from 'react';
import { ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actions from '../../stores/actions/index';

class DeleteMapDevice extends Component {

    submitModal = () => {
        const { modalData } = this.props;
        if(modalData.deleteMapDevice){
            modalData.deleteMapDevice()
        }
    }

    render () {
        const { toggleModal } = this.props;
        return (
            <React.Fragment>
                <ModalHeader toggle={toggleModal}>Delete Device</ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this device ?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="info" onClick={this.submitModal}>Confirm</Button>
                    <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                </ModalFooter> 
            </React.Fragment>
        );
    }
}

export default DeleteMapDevice;
